export interface Region {
  abbreviation: string;
  name: string;
}

export const REGIONS: Region[] = [
  { abbreviation: 'AF', name: 'Africa' },
  { abbreviation: 'AS', name: 'Asia' },
  { abbreviation: 'EU', name: 'Europe' },
  { abbreviation: 'NA', name: 'North America' },
  { abbreviation: 'OC', name: 'Australia' },
  { abbreviation: 'SA', name: 'South America' },
];

export enum RegionCode {
  UNKNOWN = 0,
  AF = 1,
  AS = 2,
  EU = 3,
  NA = 4,
  OC = 5,
  SA = 6,
  ME = 7,
  MX = 8,
}
